function makeRequest(path, method= 'GET') {
    return async function fn(params, headers, body = {}) {
        try {
            const baseUrl = new URL(`https://api.bandclead.com/${path}`)
            for (const property in params) {
                baseUrl.searchParams.append(property, params[property])
            }
            // baseUrl.searchParams.append('deleted', 'not.eq.true')
            // const fields = 'job_id,address,apartment,borough,zip,contact_name,contact_phone_number,job_size,due_date,services(service),corps(customers(customer))'
            // baseUrl.searchParams.append('select', fields)
            const response = await fetch(baseUrl, {
                method,
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                    authorization: localStorage.getItem('auth_token'),
                    ...headers
                },
                body: method === 'GET' ? null : JSON.stringify(body)
            })
            const data = await response.json()
            if (response.ok) {
                return {data, error: null}
            } else {
                console.error(data)
                // TODO: elegant error handling
                return {data: null, error: data.message}
            }
        } catch (e) {
            console.error(e)
            return {data: null, error: e}
        }
    }
}

export const loadUserId = async function () {
    const ls = localStorage.getItem('user_id')
    if (ls) {
        return ls
    } else {
        const {data} = await makeRequest('users')({'select': 'user_id', 'auth_token': `eq.${localStorage.getItem('auth_token')}`}, {...singleObjectHeader})
        localStorage.setItem('user_id', data.user_id)
        return data.user_id
    }
}

export const upsertHeader = {'Prefer': 'resolution=merge-duplicates,return=representation'}
export const singleObjectHeader = {'Accept': 'application/vnd.pgrst.object+json'}

export const loadJobs = makeRequest('job_cards')
export const loadJobDetails = makeRequest('job_details')
export const loadEditingOptions = makeRequest('job_options')

export const updateJob = makeRequest('jobs', 'PUT') // postNote({}, {"Prefer": "resolution=merge-duplicates"}, {
export const postNote = makeRequest('job_notes', 'POST')
export const postJobStage = makeRequest('job_stages', 'POST')
